if(!haxe.xml) {
 haxe.xml = {}
}
if(!haxe.xml._Fast) {
 haxe.xml._Fast = {}
}
/* End of package definition for haxe.xml._Fast */

